export const directorate = [
  {
    year: "2025",
    chairman: "Bussen",
    deputy: "Krammer",
    first_secretarary: "Breitkopf",
    second_secretary: "Fürst",
    treasury: "Sterzing",
  },
  {
    year: "2024",
    chairman: "Bussen",
    deputy: "Schmidt-Lauber",
    first_secretarary: "Breitkopf",
    second_secretary: "Fürst",
    treasury: "Sterzing",
  },
  {
    year: "2022",
    chairman: "Strittmatter",
    deputy: "Schmidt-Lauber",
    first_secretarary: "Bussen",
    second_secretary: "Fürst",
    treasury: "Kirsch",
  },
  {
    year: "2020",
    chairman: "Strittmatter",
    deputy: "Schmidt-Lauber",
    first_secretarary: "Kahlke",
    second_secretary: "Fürst",
    treasury: "Kirsch",
  },
  {
    year: "2015",
    chairman: "Strittmatter",
    deputy: "Schmidt-Lauber",
    first_secretarary: "Kirsch",
    second_secretary: "Fürst",
    treasury: "Osterholzer",
  },
  {
    year: "2011",
    chairman: "Strittmatter",
    deputy: "Schmidt-Lauber",
    first_secretarary: "Kirsch",
    second_secretary: "Raulf",
    treasury: "Osterholzer",
  },
  {
    year: "2004",
    chairman: "Strittmatter",
    deputy: "Pommer",
    first_secretarary: "Kirsch",
    second_secretary: "Raulf",
    treasury: "Osterholzer",
  },
  {
    year: "2002",
    chairman: "Kirsch",
    deputy: "Pommer",
    first_secretarary: "Junghans",
    second_secretary: "Strittmatter",
    treasury: "Osterholzer",
  },
  {
    year: "1998",
    chairman: "Kirsch",
    deputy: "Pommer",
    first_secretarary: "Junghans",
    second_secretary: "Strittmatter",
    treasury: "Lill",
  },
  {
    year: "1996",
    chairman: "Kirsch",
    deputy: "Pommer",
    first_secretarary: "Junghans",
    second_secretary: "Kiehl",
    treasury: "Lill",
  },
  {
    year: "1992",
    chairman: "Kirsch",
    deputy: "Brühl",
    first_secretarary: "Junghans",
    second_secretary: "Kiehl",
    treasury: "Lill",
  },
  {
    year: "5/1991",
    chairman: "Knoch (kommissarisch)",
    deputy: "",
    first_secretarary: "Junghans",
    second_secretary: "Brühl",
    treasury: "Alpers",
  },
  {
    year: "1991",
    chairman: "Forstmann (verstorben)",
    deputy: "Knoch",
    first_secretarary: "Junghans",
    second_secretary: "Brühl",
    treasury: "Alpers",
  },
  {
    year: "1989",
    chairman: "Forstmann",
    deputy: "Brühl",
    first_secretarary: "Junghans",
    second_secretary: "Mahlke",
    treasury: "Alpers",
  },
  {
    year: "1987",
    chairman: "Forstmann",
    deputy: "Schüler",
    first_secretarary: "Brühl",
    second_secretary: "Frank",
    treasury: "Alpers",
  },
  {
    year: "1981",
    chairman: "Forstmann",
    deputy: "Schüler",
    first_secretarary: "Girona",
    second_secretary: "Frank",
    treasury: "Alpers",
  },
  {
    year: "03.02.1979",
    chairman: "Birkner",
    deputy: "Schüler",
    first_secretarary: "Frank",
    second_secretary: "Girona",
    treasury: "Alpers",
  },
  {
    year: "23.01.1979",
    chairman: "Errichtung der Satzung: Initiator Frank",
    // deputy: "",
    // first_secretarary: "",
    // second_secretary: "",
    // treasury: "",
  },
];
